export const isYearsOfPriorActsValid = (yearsOfPriorActs: number, businessAgeInMonths: number) => {
  const businessAgeInYears = businessAgeInMonths < 12 ? 1 : Math.floor(businessAgeInMonths / 12);
  return yearsOfPriorActs <= businessAgeInYears;
};
